module.exports = require("./bg.js");